import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../ProgressHUD/index.vue'
import Api from './../../../services/api'

export default {
  name: 'ConfirmCompany',
  props: [],
  components: {
    Header,
  },
  data() {
    return {
      validationMessage: '',
      success: false,
    }
  },
  methods: {
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },
  },
  async created() {
    try {
      //if(this.$route.params)
      var token = this.$route.params.token,
        title = this.$route.params.title,
        email = this.$route.params.email

      var formData = new FormData()
      formData.append('token', token)
      formData.append('title', title)
      formData.append('email', email)

      var response = await Api.confirmCompany(formData)
      console.log(response)

      if (response.data.results != null && !response.data.error)
        this.success = true
    } catch (error) {
      console.error(error)
      this.$toast.error({
        title: 'Error',
        message: error.message,
        color: '#a21010',
      })
    }
  },
  mounted() {
    this.setHeightImage()
    window.addEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/ConfirmCompany/ConfirmCompany.component.js